import React from "react"

const PricingTable = (props) => {
  return (

    
    <div className="pricingContainer" style={{marginTop:"200px", marginBottom: "100px"}}>

        
    <stripe-pricing-table
      pricing-table-id="prctbl_1N2sVeSBtk9e2KhrR1YT6we7"
      publishable-key="pk_live_51N2pQOSBtk9e2Khrdbc41k0hWlpctgnfyVOBDtQT2gtWNHYnMk2mYZDd7yaB7rn8IxbFpuaaZ8ehNpXxpgq0mWxc00j2oqlc3N"
    >
    </stripe-pricing-table>
    </div>
  )
};

export default PricingTable;
